;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('StorageService', StorageService)

  StorageService.$inject = []

  /**
   * Constructor
   */
  function StorageService () {
    var self = this

    _.extend(self, {
      // Public Methods
      isSet: isSet,
      getData: getData,
      setData: setData,
      deleteData: deleteData
    })

    function isSet () {
      return !!self.data
    }

    function getData () {
      return self.data
    }

    function setData (value) {
      self.data = value
    }

    function deleteData () {
      delete self.data
    }
  }
})(window.angular, window._)
